import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { JobProgressProvider } from './contexts/JobProgressContext';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <JobProgressProvider>
        <App />
      </JobProgressProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

